import React from "react";
import LegalFooterBannerAndLinks from "components/legal/LegalFooterBannerAndLinks";
import LegalPagesBrandHeader from "components/legal/LegalPagesBrandHeader";
import { LEGAL_PAGES_LAST_UPDATED } from "legal/legalMeta";
import { TERMS_AND_CONDITIONS_SECTIONS } from "legal/termsAndConditionsContent";

const sections = TERMS_AND_CONDITIONS_SECTIONS;

export default function TermsAndConditions() {
  return (
    <main className="min-h-screen bg-[#0B1437] px-5 py-6 text-white sm:py-8">
      <div className="mx-auto w-full max-w-5xl">
        <LegalPagesBrandHeader />
        <header className="mb-5 space-y-2 text-center">
          <h1 className="text-3xl font-bold sm:text-4xl">Terms and Conditions</h1>
          <p className="text-sm text-gray-300">
            Last updated: {LEGAL_PAGES_LAST_UPDATED}
          </p>
          <p className="mx-auto max-w-3xl text-sm leading-relaxed text-gray-300 sm:text-base">
            This page defines membership rules, service usage conditions, and
            legal responsibilities for AlphaSniper Trading users.
          </p>
        </header>

        <section className="space-y-4">
          {sections.map((item) => (
            <article
              key={item.title}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 sm:p-6"
            >
              <h2 className="text-lg font-semibold text-white">{item.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-gray-300 sm:text-base">
                {item.body}
              </p>
              {item.title === "10. Refund Policy" && (
                <p className="mt-3 text-sm leading-relaxed text-gray-300 sm:text-base">
                  Designated broker partner requirements and verification links
                  (official partner onboarding and broker corporate sites) are
                  listed on the Refund Policy page (/RefundPolicy).
                </p>
              )}
            </article>
          ))}
        </section>

        <footer className="mt-8 border-t border-white/10 pt-5 text-xs text-gray-400 sm:text-sm">
          <p className="text-center">
            By using AlphaSniper Trading services, you acknowledge that you have
            read, understood, and accepted these Terms and Conditions.
          </p>
          <p className="mt-4 text-center">
            AlphaSniper 2026 © All Rights Reserved
          </p>
          <LegalFooterBannerAndLinks />
        </footer>
      </div>
    </main>
  );
}
